import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

export interface ReservationRestoreData {
  serviceType: string;
  airport?: string;
  flightType?: string;
  terminal?: string;
  lounge?: string;
  boardingDate?: string;
  startDateTime?: string;
  endDateTime?: string;
  spaceId?: number;
  spaceNumber?: number;
}

/**
 * 確認画面から戻ってきた際の予約データ復元を管理するフック
 * location.stateから復元データを取得し、使用後にクリアする
 */
export const useRestoreReservation = () => {
  const location = useLocation();
  const [hasCleared, setHasCleared] = useState(false);

  // location.stateから復元データを取得
  const restoreData = useMemo(() => {
    const data = (location.state as { restoreData?: ReservationRestoreData })
      ?.restoreData;
    return data;
  }, [location.state]);

  // 復元データを取得したら、historyをクリア（一度だけ実行）
  useEffect(() => {
    if (restoreData && !hasCleared) {
      window.history.replaceState({}, document.title);
      setHasCleared(true);
    }
  }, [restoreData, hasCleared]);

  return restoreData;
};
